// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lc4Sj","colMin":"styles_colMin__2NCNI"};